<template>
    <div class="w-full text-center">
        <h2 v-html="$t('FREQUENCY_SELECTION_HOW_OFTEN')"></h2>
        <div class="px-2 sm:px-20 md:px-0 lg:px-10">
            <button
                @click="selectWeekly"
                :class="weeklyButtonClass"
                class="btn btn--secondary btn--full-width my-1"
                v-html="$t('FREQUENCY_SELECTION_WEEKLY')"></button>
            <button
                @click="selectFortnightly"
                :class="fortnightlyButtonClass"
                class="btn btn--secondary btn--full-width my-1"
                v-text="$t('FREQUENCY_SELECTION_FORTNIGHTLY')"></button>
            <button
                @click="selectMonthly"
                :class="monthlyButtonClass"
                class="btn btn--secondary btn--full-width my-1"
                v-text="$t('FREQUENCY_SELECTION_MONTHLY')"></button>
        </div>
    </div>
</template>

<script>
import { PLAN_FORTNIGHTLY, PLAN_MONTHLY, PLAN_WEEKLY } from '@/constants/Gifting';

export default {
    name: 'FrequencySelection',
    mounted() {
        this.selectWeekly();
    },
    methods: {
        selectWeekly() {
            this.$store.commit('gifting/setSubscriptionFrequency', PLAN_WEEKLY);
        },
        selectFortnightly() {
            this.$store.commit('gifting/setSubscriptionFrequency', PLAN_FORTNIGHTLY);
        },
        selectMonthly() {
            this.$store.commit('gifting/setSubscriptionFrequency', PLAN_MONTHLY);
        },
    },
    computed: {
        selectedPlan() {
            return this.$store.getters['gifting/getFrequencyForSubscription'];
        },
        weeklyButtonClass() {
            return this.selectedPlan === PLAN_WEEKLY ? 'btn--active' : null;
        },
        fortnightlyButtonClass() {
            return this.selectedPlan === PLAN_FORTNIGHTLY ? 'btn--active' : null;
        },
        monthlyButtonClass() {
            return this.selectedPlan === PLAN_MONTHLY ? 'btn--active' : null;
        },
    },
};
</script>
